import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

export const SYSTEM_TEMPLATE_TRANSLATIONS_QUERY_KEY = 'systemTemplateTranslations';

export const useSystemTemplateTranslations = ({
	enabled = true,
	id,
	meta,
}: {
	enabled?: boolean;
	id: string;
	meta?: LevStandardQueryMeta;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			// Must use /template route otherwise calls for customers will fail.
			const value = await userSession.webServiceHelper.callAsync<Api.ITemplate[]>(`template/${id}/translations`, 'GET');
			return value;
		},
		queryKey: [SYSTEM_TEMPLATE_TRANSLATIONS_QUERY_KEY, id],
		meta,
	});
};
